<template>
  <div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <list-btn :listArr="listArr"></list-btn>

    <!-- 操作按钮  -->
    <list-btn
    ref="actionbtn"
    @uploadBtn="uploadBtn"
    :listArr="listArr"
    :sdata="sdata"
    @detail="goDetail"
    @edit="edit"
    @add="add"
    @del="del"
    isAdd
    isEdit
    isDel
    ></list-btn> 

    <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData" 
      :columns="tabColumns"
      tabName="bomScan-list"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick"
    ></tab-list>

    <!-- 详情 -->
    <el-dialog
      title="销售详情"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag
      @closed="closedDialog"
    >
      <v-detail :sdata="detailSdata" class="contnet_box"></v-detail>
    </el-dialog>
  </div>
</template>

<script>
import { bomApi } from "api/base.js";
import {excelUpload,excelDownload} from 'api/excel.js'
import listBtn from "components/btn/listBtn.vue";
import tabList from "components/table/list.vue";
import searchBox from "./components/bomScan/search.vue";
import vDetail from "./components/bomDetail.vue";
import dialogDetail from 'components/common/detail.vue';



export default{
  components: {
    listBtn,
    tabList,
    searchBox,
    vDetail,
    dialogDetail
  },
  data() {
    return {
      loading:true,
      isComponentChild:false,
      dialogFormVisible: false,
      detailSdata: [],
      sdata: {},
      listArr: [],
      tabColumns: [
        {field: "materialCode",title: "物料编码",need: true,width: 120,sortable: true},
        { field: "materialDesc", title: "物料描述",need: true},
        { field: "factoryCode", title: "工厂编码"},
        { field: "basicNum", title: "基本数量"},
        { field: "bomBasicUnitName", title: "基本计量单位"},
        { field: "optionBom", title: "BOM版本" },
        {field: "bomStatus", title: "BOM状态"},
        { field: "startDate", title: "有效起始日" }
      ], //表头字段
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 20, //每页显示的数量,
        searchCriteria: {
          //查询的附加条件
        }
      },
      sfromData: {
        bomBillId: 0
      }
    };
  },
  created() {
    this.getList();
  },
  mounted(){
    this.isComponentChild = true;
  },
  methods: {
    //双击
    dbClick(data) {
      this.sdata = data;
      this.goDetail();
    },
    //选中数据
    selectSdata(data) {
      console.log(data);
      this.sdata = data;
      this.sfromData.bomBillId = data.bomBillId;
    },
    //获取列表
    async getList() {
      let res = await this.$post(bomApi.list,this.fromData);
      console.log(res);
      if (res.status && res.data) {
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      } else {
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
      this.loading = false;
      this.isComponentChild = true;
    },
    //当前页码改变
    currentChange(currentPage) {
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages) {
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    //搜索
    subSearch() {
      console.log(this.fromData);
      this.fromData.page = 1;
      this.getList();
    },
    
    //新增 
    add(){
      this.$router.push({'name':'base-bom-bomNew'});
    },
    //编辑
    edit(){
      if(!this.sdata.bomBillId){
        this.$message.error('请选择需要编辑的记录');
        return;
      }
      this.$router.push({name: 'base-bom-bomEdit', params:{id:this.sdata.bomBillId}});
    },
    uploadBtn(){
      this.$refs.actionbtn.uploadDialog = true;
    },
    //详情
    async goDetail() {
      if (!this.sdata.bomBillId) {
        this.$message.error("请选择要查看的记录");
        return;
      }
      let res = await this.$get(bomApi.find, this.sfromData);
      this.dialogFormVisible = true;
      console.log(res.data.bomComponent);
      if (res.status){
        this.detailSdata = res.data.bomComponent;
      }
    },
    //关闭弹出层
    closedDialog() {
      this.dialogFormVisible = false;
    },
    //删除
    del() {
      let vm = this;
      console.log(vm.sdata.bomBillId)
      if (!this.sdata.bomBillId) {
        this.$message.error("请选择需要删除的");
        return;
      }
      this.$confirm("确定删除这条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await vm.$get(bomApi.del, {
            bomBillId: vm.sdata.bomBillId
          });
          const { data, msg, status, code } = res;
          if (status) {
            this.sdata.isDel = true;
            this.listArr[this.sdata.index] = this.sdata;
            vm.$message.success("操作成功");
            this.getList()
          } else {
            vm.$message.error("操作失败");
          }
        })
        .catch(() => {
          this.$message.success("已取消删除");
        });
    },
    //恢复删除
    // restore() {
    //   let vm = this;
    //   if (!this.sdata.bomBillId) {
    //     this.$message.error("请选择需要恢复的物料");
    //     return;
    //   }
    //   this.$confirm("恢复此条记录, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   }).then(async () => {
    //     let res = await vm.$get(bomApi.restore, { 
    //       bomBillId: this.sdata.bomBillId
    //     });
    //     const { data, msg, status, code } = res;
    //     if (status) {
    //       this.sdata.isDel = false;
    //       this.listArr[this.sdata.index] = this.sdata;
    //       vm.$message.success("操作成功");
    //     } else {
    //       vm.$message.error("操作失败");
    //     }
    //   });
    // }
  }
};
</script>

<style lang="stylus" scoped></style>
